// EL ERROR DEL CALENDARIO, EN PALABRAS (Lissette 2026-10-15).
//
// En "Enviar mis citas a mi calendario (dos vías)" salía la respuesta cruda de
// Google: `Google list events failed: 403 { "error": … "insufficientPermissions" … }`.
// Quiere decir que al conectar, en la pantalla de Google, la casilla del
// calendario quedó SIN marcar: Google conecta la cuenta igual, pero sin permiso
// para ver ni crear eventos. Eso se arregla desconectando y volviendo a
// conectar con la casilla marcada, y eso es lo que hay que decirle a la agente.
//
// El servidor guarda el código `calendar-scope-missing`; los errores viejos,
// guardados antes de este cambio, traen el texto crudo y también se reconocen.

export const SIN_PERMISO_DE_CALENDARIO = 'calendar-scope-missing';

export function esFaltaDePermiso(err) {
  const s = String(err || '');
  return s === SIN_PERMISO_DE_CALENDARIO
    || /insufficientPermissions|insufficient authentication scopes|ACCESS_TOKEN_SCOPE_INSUFFICIENT/i.test(s);
}

/** Lo que se le enseña a la agente. Cualquier otro error, tal cual. */
export function textoDeErrorDelCalendario(err, lang) {
  if (!esFaltaDePermiso(err)) return String(err || '');
  return lang === 'es'
    ? 'Google conectó tu cuenta pero sin permiso para tu calendario: en la pantalla de Google quedó sin marcar la casilla del calendario. Pulsa "Desconectar", vuelve a conectar Google y marca la casilla "Ver, editar, compartir y borrar… los eventos de tus calendarios" antes de continuar.'
    : 'Google connected your account without calendar permission: the calendar checkbox was left unticked on Google\'s screen. Click "Disconnect", connect Google again and tick the "See, edit, share and permanently delete… events on your calendars" box before continuing.';
}
